import { render, staticRenderFns } from "./Promociones.vue?vue&type=template&id=e7020748&"
import script from "./Promociones.vue?vue&type=script&lang=ts&"
export * from "./Promociones.vue?vue&type=script&lang=ts&"
import style0 from "./Promociones.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports